import cx from 'classnames'
import NextImage from 'next/image'
import { useMemo } from 'react'

import { type SanityImageFragment } from '@data/sanity/queries/types/image'
import { getBasicImageLoader, getSanityImageUrl } from '@lib/image'

interface ModalGalleryImageProps {
  image: SanityImageFragment
  alt: string
  onClose: () => void
  className?: string
}

const ModalGalleryImage = ({
  image,
  alt,
  onClose,
  className,
}: ModalGalleryImageProps) => {
  const imageUrl = useMemo(() => getSanityImageUrl(image), [image])

  if (!imageUrl) {
    return
  }

  const aspectRatio = image.asset?.metadata?.dimensions?.aspectRatio ?? 1
  const imageWidth = image.asset?.metadata?.dimensions?.width ?? 1200
  const imageHeight = imageWidth / aspectRatio

  return (
    <NextImage
      src={imageUrl}
      width={imageWidth}
      height={imageHeight}
      alt={alt}
      loader={getBasicImageLoader}
      onClick={onClose}
      className={cx('w-full h-auto', className)}
    />
  )
}

export default ModalGalleryImage
